import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useRef } from 'react';

/**
 * use for queries that only need the first valid response
 * - gas limit estimation
 */
export const useQueryOnce = <
  TData = unknown,
  TError = Error,
  TSelect = TData,
  TKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TData, TError, TSelect, TKey>,
) => {
  const queriedOnce = useRef(false);

  return useQuery({
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    placeholderData: (p) => p,
    ...options,
    queryFn: async (ctx) => {
      if (!options?.queryFn) {
        throw new Error('missing queryFn');
      }

      const res = await options?.queryFn?.(ctx);
      queriedOnce.current = true;

      return res;
    },
    enabled: !queriedOnce.current && (options?.enabled ?? true),
  });
};
